import { render, staticRenderFns } from "./principalMenuItem.vue?vue&type=template&id=6e8e27f2&scoped=true&"
import script from "./principalMenuItem.vue?vue&type=script&lang=js&"
export * from "./principalMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./principalMenuItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./principalMenuItem.vue?vue&type=style&index=1&id=6e8e27f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e27f2",
  null
  
)

export default component.exports